import { render } from "./BusinessSection.vue?vue&type=template&id=1debddb6&scoped=true"
import script from "./BusinessSection.vue?vue&type=script&lang=js"
export * from "./BusinessSection.vue?vue&type=script&lang=js"

import "./BusinessSection.vue?vue&type=style&index=0&id=1debddb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1debddb6"]])

export default __exports__